import { Box, createListCollection, Portal } from "@chakra-ui/react"
import { Table, Spinner, TableCaption, Select, Flex, Heading, Text, } from '@chakra-ui/react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useCache } from "../../context/CacheContext";
import { useWebHelper } from "@viabl/echo-web-client-core";
import InfiniteScroll from 'react-infinite-scroll-component';
import TableControlsPermissions from "../../components/table/tableControlsPermissions";
import { useColorMode } from "../../components/ui/color-mode";
import { Toaster, toaster } from "../../components/ui/toaster";
import TableControls2 from "../../components/table/tableControlsComponent";
import AnnouncementEditor from "../../components/announcement/announcementEditor";
import AnnouncementView from "../../components/announcement/announcementView";
import AnnouncementReadRecipts from "../../components/announcement/announcementReadRecipts";

export interface Type {
    id: string,
    name: string,
}

interface IPageContainerProps {
    pageTitle: string,
    children: React.ReactNode;
}

interface IAllocationModel {
    accepted: boolean,
    appointment_id: string
}

export interface IAnnouncement {
    id: string;
    title: string;
    subtitle: string;
    body: string;

    read_receipts: any[]

    target_groups: string[];

    created: string;
    last_modified: string;
    published: string | null;

    modified_by_id: string;
    modified_by_name: string;

    status: string;
    is_acceptable: boolean;

    attributes: object[] | null;

    target_type: string;
}

export interface ICreateAnnouncement {
    title: string,
    subtitle: string,
    body: string,
    tags: string[],
    isAcceptable: boolean,
}

const collection = createListCollection({
    items: [
        { label: "All", value: "all" },
        { label: "Pending", value: "pending" },
        { label: "Active", value: "active" },
        { label: "Archived", value: "archived" },
    ],
})

export const AnnoucementsPage = () => {
    const CacheContext = useCache();
    const [rows, setRows] = useState<IAnnouncement[]>([]);
    const [statusFilter, setStatusFilter] = useState<string>("all")
    const [maxPages, setMaxPages] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedType, setSelectedType] = useState<string>("803130a7-7a5c-43d3-b850-bf8ecba20cd9");
    const [nextPage, setNextPage] = useState<IAnnouncement[]>([]);
    const [nextPageNo, setNextPageNo] = useState<number>(0);
    const { colorMode, toggleColorMode } = useColorMode();

    const webHelpers = useWebHelper();

    

    useEffect(() => {
        if (webHelpers.selectedEnvironment === null || webHelpers.selectedEnvironment === undefined) {
            console.log("environment is null?")
        }
    }, [])

    // useEffect(() => {
    //     setRows([])
    // }, [webHelpers.selectedEnvironment])

    function goToNextPage(pageToLoad: number) { //used for infinite scrolling
        webHelpers.GetAsync("/api/announcements?page=" + (pageToLoad + 1) + "&pageSize=" + rowsPerPage + "&query=" + search + (statusFilter !== "all" ? "&status=" + statusFilter : ""), "iris-api").then((data: any) => {
            console.log(data)
            if (data === undefined || data === null) {
                console.log(`No users found by the name "${search}", please try another search`, { 'variant': 'error' })
                setLoading(false);
            }
            else {
                console.log(data);
                setNextPage(data.results)
                data.results.forEach((element: IAnnouncement) => {
                    setRows(rows => [...rows, element])
                })
                console.log(data.total_pages)
                setMaxPages(data.total_pages)
                console.log(rows)
                setLoading(false);
            }
        });
    }

    useEffect(() => {
        console.log(nextPageNo)
        setNextPageNo(0);
    }, [page]);

    function updateTable() {
        setLoading(true)
        setNextPageNo(page);
        webHelpers.GetAsync(
            "/api/announcements?page=" + (page + 1) + "&pageSize=" + rowsPerPage + "&query=" + search + (statusFilter !== "all" ? "&status=" + statusFilter : ""), "iris-api").then((data: any) => {
                console.log(data)
                if (data === undefined) {
                    toaster.create({

                        title: `${data}: Unable to fetch announcements from the API`,
                        type: "error",

                    });
                } else {
                    setRows(data.results);
                    setMaxPages(data.total_pages);
                    setLoading(false);
                }
            }
            ).catch((error) => {
                setLoading(false);
                toaster.create({

                    title: `${error.status}: Unable to fetch announcements from the API`,
                    type: "error",

                });
            });
    }

    useEffect(() => {
        updateTable();
    }, [
        page,
        rowsPerPage,
        search,
        statusFilter,
        webHelpers.selectedEnvironment
    ]);

    useEffect(() => {
        console.log(statusFilter)
        if (page !== 0) {
            setPage(0);
        }
    }, [statusFilter])

    const handleSearchChange = (event: any) => {
        const searchValue = event.target.value
        setSearch(searchValue);
        setPage(0);
        console.log(search)
    }

    const handleChangeRowsPerPage = (event: any) => {
        setLoading(true)
        setRowsPerPage(event.value[0]);
        setPage(0);
    };

    useEffect(() => {
        setRows([])
        if (page !== 0) {
            setPage(0);
        }
    }, [webHelpers.selectedEnvironment])

    const handleEnvChange = (event: any) => {
        setLoading(true);
        let isSuccess: boolean = webHelpers.SetEnvironmentById(event.value[0]);
        console.log(isSuccess);
    }

    return (
        <Flex direction={"column"}>
            <Toaster />
            <Heading marginTop={"20px"} color={colorMode === "light" ? "AbleBlue" : "AbleYellow"} as={"i"} justifySelf={"center"} display={"block"} fontWeight={"lighter"}
            >Engineer App Announcements</Heading>
            <Flex direction={"row"} justifyContent={"center"} marginTop={"10px"}>
                <div>
                    {/* <ScaleFade initialScale={1} in={true}> */}
                    <Flex direction={"row"} justifyContent={"center"}>
                        <TableControlsPermissions handleChangeRowsPerPage={handleChangeRowsPerPage} search={search} handleSearchChange={handleSearchChange} rowsPerPage={rowsPerPage} />
                        <TableControls2 handleEnvChange={handleEnvChange} handleSearchChange={handleSearchChange} handleProfileChange={() => console.log("")} syncHandler={() => console.log("")} search={search} selectedType={selectedType}
                            userTypes={undefined} showTwilioSync={false} showUserTypes={false} handleLoadingChange={setLoading} handleRowsPerPageChange={handleChangeRowsPerPage} refresh={updateTable} page={page} maxPage={maxPages} setPage={setPage} rowsPerPage={rowsPerPage} />
                        <Select.Root collection={collection} size={"sm"} w={{base: "70px", lg: "137px"}} paddingLeft={"0px"} marginTop={"10px"} ml={5} zIndex={100} justifyContent={"center"} onValueChange={(e) => setStatusFilter(e.value[0])} defaultValue={["all"]}>
                            <Select.HiddenSelect />
                            <Select.Control>
                                <Select.Trigger w={{base: "70px", lg: "137px"}}>
                                    <Select.ValueText placeholder="Select..." />
                                </Select.Trigger>
                                <Select.IndicatorGroup>
                                    <Select.Indicator />
                                </Select.IndicatorGroup>
                            </Select.Control>
                            <Portal>
                                <Select.Positioner>
                                    <Select.Content>
                                        {collection.items.map((item) => (
                                            <Select.Item item={item} key={item.value}>
                                                {item.label}
                                                <Select.ItemIndicator />
                                            </Select.Item>
                                        ))}
                                    </Select.Content>
                                </Select.Positioner>
                            </Portal>
                        </Select.Root>
                        <Box marginTop={2.5}>
                            <AnnouncementEditor intent="create" existingAnnouncement={null} cb={updateTable} />
                        </Box>
                        
                    </Flex>
                    {/* need to have a section or method of showing already selected skills */}
                    {!loading ?
                        <>
                            {rows.length > 0 ?
                                // <ScaleFade initialScale={1} in={!loading}>
                                <Flex h={750 * ((rows.length / rowsPerPage) + 1) + 10 + "px"}>
                                    <>

                                        <Table.Root variant={"line"}>
                                            {rows.length === 0 ?
                                                <Text textAlign={"center"}>No Annoucements Found! </Text>
                                                :
                                                <>

                                                    <InfiniteScroll
                                                        dataLength={rows.length}
                                                        next={() => {

                                                            if (nextPageNo < page) {
                                                                setNextPageNo(page + 1);
                                                                goToNextPage(page + 1)
                                                            }
                                                            else {
                                                                goToNextPage(nextPageNo + 1)
                                                                setNextPageNo(nextPageNo + 1);
                                                            }
                                                        }}
                                                        hasMore={nextPageNo <= maxPages - 2}
                                                        loader={
                                                            <Flex direction={"row"} justifyContent={"center"} width={"100%"} bgColor={colorMode === "light" ? "backgroundDarkGrey" : "backgroundGrey"} marginTop={{ base: "170px", lg: "100px" }}>
                                                                <Spinner color={colorMode === "light" ? "AbleBlue" : "AbleYellow"} marginTop={"10px"} marginBottom={"100px"} size={"xl"} display={(nextPageNo < maxPages) && nextPageNo !== 1 ? "flex" : "none"}></Spinner>
                                                                {/* <Image srcSet={loadingGif} alt="loading..." boxSize={'400px'} objectFit={"cover"} /> */}
                                                            </Flex>
                                                        }
                                                        endMessage={
                                                            <p style={{ textAlign: 'center' }}>
                                                                <b>{rows.length < rowsPerPage ? " " : "End of Results"}</b>
                                                            </p>
                                                        }
                                                        scrollThreshold={0.75}
                                                    >
                                                        <TableCaption>
                                                            <Text>
                                                                {rows.length < rowsPerPage ? " " : "Scroll Down to Load More Results"}
                                                            </Text>
                                                        </TableCaption>
                                                        <Table.Header>
                                                            <Table.Row>
                                                                {/* this will show all skill that are possible to see */}
                                                                <Table.ColumnHeader textAlign={"Left"}>Title</Table.ColumnHeader>
                                                                <Table.ColumnHeader display={{ base: "none", lg: "revert" }}>Tags</Table.ColumnHeader>
                                                                <Table.ColumnHeader display={{ base: "none", lg: "revert" }}>Status</Table.ColumnHeader>
                                                                <Table.ColumnHeader display={{ base: "none", lg: "revert" }}>Read Receipets</Table.ColumnHeader>
                                                                <Table.ColumnHeader display={{ base: "none", lg: "revert" }}></Table.ColumnHeader>
                                                                <Table.ColumnHeader display={{ base: "none", lg: "revert" }}></Table.ColumnHeader>
                                                                {/* <Table.ColumnHeader display={{ base: "none", lg: "revert" }}>Edit</Table.ColumnHeader> */}
                                                            </Table.Row>
                                                        </Table.Header>
                                                        <Table.Body>
                                                            {rows.map((announcement: IAnnouncement) =>
                                                                <Table.Row>
                                                                    <Table.Cell paddingRight={{base: "20px",lg: "100px"}}>{announcement.title}</Table.Cell>
                                                                    <Table.Cell width={200} paddingRight={"100px"} display={{ base: "none", lg: "revert" }}>{announcement.target_groups?.join(", ")}</Table.Cell>
                                                                    <Table.Cell paddingRight={"100px"} display={{ base: "none", lg: "revert" }}>{announcement.status}</Table.Cell>
                                                                    <Table.Cell paddingRight={"100px"} display={{ base: "none", lg: "revert" }}>{announcement.is_acceptable ? <AnnouncementReadRecipts ReadRecipts={announcement.read_receipts} /> : "No"}
                                                                    </Table.Cell>
                                                                    <Table.Cell paddingRight={{base: "20px",lg: "100px"}} >
                                                                        {announcement.status !== "Pending" ?
                                                                            <AnnouncementView intent={"view"} existingAnnouncement={announcement} cb={updateTable} />
                                                                            :
                                                                            <AnnouncementEditor intent="edit" existingAnnouncement={announcement} cb={updateTable} />}
                                                                    </Table.Cell>
                                                                    <Table.Cell >
                                                                        <Flex justify="center" align="center">
                                                                            {announcement.status !== "Archived" && <AnnouncementView intent={announcement.status === "Active" ? "archive" : "publish"} existingAnnouncement={announcement} cb={updateTable} />}
                                                                        </Flex>
                                                                        
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                            )}
                                                        </Table.Body>
                                                    </InfiniteScroll>

                                                </>
                                            }
                                        </Table.Root>
                                    </>
                                </Flex>
                                // </ScaleFade>


                                :
                                <Flex justifyContent={"center"} marginTop={"100px"}>
                                    <Text>No Announcements Found!</Text>
                                </Flex>
                            }

                        </>

                        :

                        <Flex width={"100%"} justifyContent={"center"}>
                            <Spinner color={colorMode === 'light' ? "AbleBlue" : "AbleYellow"} size={"xl"} marginTop={"100px"} marginBottom={"100px"} />
                        </Flex>
                    }
                    {/* </ScaleFade> */}
                </div>




            </Flex>
        </Flex >
    )
}
